class HeroVideo {
  constructor(element) {
    this.element = element
    this.video = element.querySelector('video')
    this.playButton = element.querySelector('button[type="button"]')
    this.playing = false
    this.respectReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches

    this.init()
    this.bindEvents()
  }

  init() {
    // Set initial playing state based on reduced motion preference
    this.playing = !this.respectReducedMotion

    // Set initial video state
    if (this.video) {
      if (this.playing) {
        this.video.play().catch(() => {
          // Handle autoplay failure gracefully
          this.playing = false
        })
      } else {
        this.video.pause()
      }
    }

    // Update button state
    this.updateButtonState()
  }

  bindEvents() {
    if (this.playButton) {
      this.playButton.addEventListener('click', this.togglePlay.bind(this))
    }

    // Listen for reduced motion preference changes
    window.matchMedia('(prefers-reduced-motion: reduce)').addEventListener('change', (e) => {
      this.respectReducedMotion = e.matches
      if (this.respectReducedMotion && this.playing) {
        this.togglePlay()
      }
    })
  }

  togglePlay() {
    if (!this.video) return

    if (this.playing) {
      this.video.pause()
      this.playing = false
      this.updateButtonState()
    } else {
      this.video.play().then(() => {
        this.playing = true
        this.updateButtonState()
      }).catch(() => {
        // Handle play failure gracefully
        this.playing = false
        this.updateButtonState()
      })
    }
  }

  updateButtonState() {
    if (!this.playButton) return
    const playIcon = this.playButton.querySelector('[data-icon="play"]')
    const pauseIcon = this.playButton.querySelector('[data-icon="pause"]')

    if (playIcon && pauseIcon) {
      if (this.playing) {
        playIcon.style.display = 'none'
        pauseIcon.style.display = 'block'
        this.playButton.setAttribute('aria-label', 'Pause background video')
      } else {
        playIcon.style.display = 'block'
        pauseIcon.style.display = 'none'
        this.playButton.setAttribute('aria-label', 'Play background video')
      }
    }
  }
}

// Initialize hero video functionality
const heroSections = document.querySelectorAll('section.hero, section.hero-alt')

heroSections.forEach(function (element) {
  // Only initialize if there's a video element
  if (element.querySelector('video')) {
    new HeroVideo(element)
  }
})
